import React from "react";
import TemplatePreview from "./TemplatePreview";
import EmailEditorModal from "./EmailEditorModal";

// The email body is stored as HTML (written in the rich-text editor).
const renderBody = (template) => (
  <div
    className="tpv-body tpv-body-email"
    dangerouslySetInnerHTML={{ __html: template.description }}
  />
);

function EmailTemplate() {
  return (
    <TemplatePreview
      fetchPath="getEmailTemplate"
      deletePath="deleteTemplate"
      headlineLabel="Subject"
      getHeadline={(t) => t.email_subject}
      bodyLabel="Email body"
      noun="email"
      renderBody={renderBody}
      Editor={EmailEditorModal}
    />
  );
}

export default EmailTemplate;
